export default "__VITE_ASSET__HJ9zpsQKAVY6q4TZj9w_SA__"